const ptMessages = {
  /* 01.General */
    "main.name": "Nome",
  "main.sentiment": "Sentimento",
  "main.urgency": "Urgência",
  "main.language": "Idioma",
  "main.agent": "Agente",
  "main.property_name": "Nome da propriedade",
  "main.booking_number": "Número da reserva",
  "main.check_out": "Check-out",
  "main.check_in": "Check-in",
  "main.adults": "Adultos",
  "main.corporate_code": "Código empresarial",
  "main.group_code": "Código do grupo",
  "main.promo_code": "Código promocional",
  "main.ai_response": "Resposta da IA",
  "main.template_response": "Resposta do modelo",
  "main.converttoticket": "Converter em bilhete",
  "main.switch_property": "Mudar propriedade",
  "main.Group_id": "ID do grupo",
  "main.integration_id": "ID de integração",
  "main.submit": "Enviar",
  "main.cancel": "Cancelar",
    "main.select_template": "Selecionar um modelo",
  "main.rooms": "Quartos",
  "main.rates": "Tarifas",

  //footer
    "footer.knowledge": "Conhecimento",
  "footer.home": "Página inicial",
  "footer.help": "Ajuda",

  //ticket
  "ticket.thank_you": "Obrigado por enviar o formulário",
  "ticket.ticket": "Bilhete",
  "ticket.details": "Preencha o formulário descrevendo os detalhes do bilhete.",
  "ticket.select_category": "Selecionar categoria",
  "ticket.category": "Categoria",
  "ticket.title": "Título",
  "ticket.notes": "Notas",
  "ticket.status": "Estado",
  "ticket.assigned_to": "Atribuído a",
  "ticket.submit_form": "Enviar formulário",

  
  "main.total": "Total",
  "main.pastetooutlook": "Colar no Outlook",
  "main.children": "Crianças",
  "main.promocode": "Código promocional/empresarial/grupo",
  "main.exact_match_only": "Apenas correspondência exata",
  "main.search": "Pesquisar",
  "main.no_rate_match": "Não existem tarifas correspondentes à sua seleção. Altere a pesquisa e tente novamente.",
  "main.translate_to": "Traduzir para",
  "main.regenerate": "Regenerar",
  "main.copy_text": "Copiar texto",
  "main.additional_instructions": "Instruções adicionais",

  "faq.helpcenter": "Centro de ajuda",
  "faq.reply.email.sabre.question": "Como respondo a um e-mail utilizando a Aven Hospitality Concierge Email Automation?",
  "faq.reply.email.sabre.answer": "Abra o e-mail e inicie o suplemento Aven Hospitality. Pode escolher entre três opções: utilizar um modelo predefinido, gerar uma resposta de IA ou converter o e-mail num ticket. Escolha a opção mais adequada, reveja a resposta, faça alterações se necessário e envie diretamente pelo Outlook.",

  "faq.rates.availability.question": "Como adiciono tarifas, disponibilidade e detalhes dos quartos à minha resposta?",
  "faq.rates.availability.answer": "Utilize a funcionalidade + Rates para inserir detalhes dos hóspedes, como datas e número de hóspedes. O Concierge irá inserir disponibilidade e preços corretos na resposta. Também pode utilizar + Rooms para incluir descrições e imagens dos quartos.",

  "faq.different.language.question": "O que devo fazer se o e-mail estiver numa língua diferente?",
  "faq.different.language.answer": "Aven Hospitality Concierge permite traduzir e-mails recebidos para o seu idioma preferido. Depois pode gerar ou editar uma resposta e traduzi-la novamente para o idioma do hóspede antes de enviar.",

  "faq.pin.addin.question": "Como garantir que o suplemento está sempre disponível no Outlook?",
  "faq.pin.addin.answer": "Para manter o Aven Hospitality Concierge sempre visível, fixe o suplemento no Outlook. Isto permite que seja aberto automaticamente com cada e-mail.",

  "faq.knowledge.hub.question": "O que é a opção de pesquisa Knowledge Hub?",
  "faq.knowledge.hub.answer": "A pesquisa Knowledge Hub permite encontrar rapidamente informações específicas da propriedade diretamente no Outlook.",

  "faq.reply.email.myma.question": "Como respondo a um e-mail utilizando o Myma?",
  "faq.reply.email.myma.answer": "Abra o e-mail e inicie o suplemento Myma. Pode utilizar um modelo, gerar uma resposta de IA ou converter o e-mail num ticket.",

  "faq.room.details.question": "Como adiciono detalhes dos quartos à minha resposta?",
  "faq.room.details.answer": "Utilize + Rooms para incluir descrições e imagens dos quartos.",

  "faq.myma.different.language.question": "O que devo fazer se o e-mail estiver numa língua diferente?",
  "faq.myma.different.language.answer": "O Myma permite traduzir e-mails recebidos para o seu idioma preferido.",

  "faq.myma.pin.addin.question": "Como garantir que o suplemento está sempre disponível no Outlook?",
  "faq.myma.pin.addin.answer": "Fixe o suplemento Myma no Outlook para que abra automaticamente com cada e-mail.",

};
export default ptMessages;
